<template>
  <div class="">
    <h1>Oops, it looks like the page you're looking for doesn't exist. 404</h1>
  </div>
</template>
